import {AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Message} from '@models/message';
import {MessageService} from '@services/message/message.service';
import {MatDialog} from '@node_modules/@angular/material';
import {ElementRef, ViewChild} from '@node_modules/@angular/core';
import {User} from '@models/user';
import {SchoolService} from '@services/school/school.service';
import {StudentService} from '@services/student/student.service';
import {TeacherService} from '@services/teacher/teacher.service';
import * as AuthReducer from '@store/auth/reducers';
import {Store} from '@node_modules/@ngrx/store';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {UpdateAuthUser} from '@store/auth/actions';
import {AngularEditorConfig} from '@node_modules/@kolkov/angular-editor';
import {ProgramService} from '@services/program/program.service';
import {SchoolOwner} from '@interfaces/schoolOwner';
import {AccountService} from '@services/account/account.service';
import {AddRecipientsComponent} from '@pages/layout/messages/message-page/add-recipients/add-recipients.component';
import {Program} from '@models/program';
import * as ProgramReducer from '@store/program/reducers';
import {SetPrograms} from '@store/program/actions';
import {Class} from '@models/class';
import {School} from '@models/shool';
import {SystemMessage} from '@models/systemMessage';
import {EventInterface} from '@interfaces/event.interface';
import {MessageReplacementInterface} from '@interfaces/messageReplacement.interface';
import {ConditionInterface} from '@interfaces/condition.interface';
import {ModalCalendarComponent} from '@components/modal-calendar/modal-calendar.component';
import * as moment from 'moment';
import {MessageTemplateInterface} from '@interfaces/messageTemplate.interface';
import {forEach} from '@node_modules/@angular/router/src/utils/collection';
import {Router} from '@node_modules/@angular/router';

@Component({
  selector: 'app-message-page',
  templateUrl: './message-page.component.html',
  styleUrls: ['./message-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessagePageComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('subject') subject: ElementRef;
  @ViewChild('nameSystemMessage') nameSystemMessage: ElementRef;
  @ViewChild('numberConditionsItems') numberConditionsItems: ElementRef;
  // @ViewChild('body') body: ElementRef;
  user: User;
  programs: Program[] = [];
  classes: Class[] = [];
  recipients: number[] = [];
  recipientsUsers: User[] = [];
  inboxMessages: Message[] = [];
  draftMessages: Message[] = [];
  trashMessages: Message[] = [];
  sentMessages: Message[] = [];
  systemMessages: SystemMessage[] = [];
  messagesByThread: Message[] = [];
  activeTab = 'inbox';
  // activeTabRecievers = 'all';
  selectedMessage: Message;
  selectedThreadMessage: Message;
  creatingNew = false;
  editing = false;
  systemMessageMode = 'auto';
  // schoolsUsers: User[] = [];
  // schoolsTeachers: User[] = [];
  // schoolsStudents: User[] = [];
  // schoolsOwners: SchoolOwner[] = [];
  checkAllStatus = false;
  toggle = false;
  confirmDialog;
  recipientsDialog;
  subscribes = [];
  htmlContent = '';
  autoSending = false;
  conditions: ConditionInterface[];
  selectedCondition: ConditionInterface;
  calendarDialog;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    uploadUrl: 'image',
  };
  // (709) Media insert panels — Messages editor
  videoPanel: {open: boolean; mode: string; urlValue: string; embedValue: string; videoSize: string; videoLayout: string; error: string} = {
    open: false, mode: 'url', urlValue: '', embedValue: '', videoSize: 'medium', videoLayout: 'center', error: ''
  };
  imagePanel: {open: boolean; imageSize: string; imageLayout: string} = {
    open: false, imageSize: 'small', imageLayout: 'center'
  };
  private msgSavedRange: Range | null = null;
  private msgImagePanelObserver: MutationObserver | null = null;
  private readonly msgMediaHelperHtml =
    '<div class="mkc-media-helper-text">' +
    '<p>Replace this text with your own</p>' +
    '<ul><li>Write your bullet points</li>' +
    '<li>Add more details here</li>' +
    '</ul></div>' +
    '<div class="mkc-media-clearfix"></div>';

  selectedRecipients: { id: number; itemName: string; mode?: string; }[] = [];
  selectedRecipientsOrigin: { id: number; itemName: string; mode?: string; }[] = [];
  selectedEvents: EventInterface[] = [];
  usedReplacements: string[] = [];
  selectedSpecifricDay = moment().format('ll');
  dropdownSettings = {
    // disabled: true,
    singleSelection: false,
    text: 'Recipients',
  };
  dropdownSettingsEvents = {
    singleSelection: false,
    maxHeight: 250,
    text:"Select Event",
    position: 'bottom',
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"multi-select-events"
  };
  dropdownSettingsReplacements = {
    singleSelection: false,
    maxHeight: 250,
    text:"Select Event",
    position: 'bottom',
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"multi-select-replacements"
  };
  page: 0;
  selectedThreadId: number;
  parentRef = this;
  bundleRecipients: {school: number, program: number, classc: number, curriculum: number , selectedCurriculumProgramId: number} =
    {school: 0, program: 0, classc: 0, curriculum: 0, selectedCurriculumProgramId: 0};
  selectedRecipientsRole = 'all';
  events: EventInterface[] = [];
  replacements: MessageReplacementInterface[] = [];
  recipientsNameReplacement: MessageReplacementInterface;
  confirmModal;
  static instance = null;
  draggableItems = [];
  itemMoved = 0;
  confirmModalDelete;
  permanentDeleteMsgRef;
  isDarkTheme = false;

  constructor(
    private messageService: MessageService,
    private schoolService: SchoolService,
    private studentService: StudentService,
    private programService: ProgramService,
    private teacherService: TeacherService,
    private accountService: AccountService,
    private programStore: Store<ProgramReducer.ProgramState>,
    private authStore: Store<AuthReducer.AuthState>,
    public dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit() {
    this.isDarkTheme = localStorage.getItem('mkc-dashboard-theme') === 'dark';
    this.applyTheme();

    MessagePageComponent.instance = this;
    this.getMessages();
    console.log(this);
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        this.programs = val.program.programs;
        if (auth && auth.user) {
          this.user = auth.user;
          if (this.user.not_read_messages > 0 && auth.lastAction === 'UPDATE_NOT_READ_MESSAGES') {
            this.resetTabsAndPageNumber();
            this.getMessages();
          }
        }
      }
    ));
    setTimeout(() => {
      if (!this.programs || this.programs.length === 0) {
        this.getPrograms();
      } else {
        const clIds = [];
        this.programs.map(pr => {
          pr.classes.map(cl => {
            if (!clIds.includes(cl.id)) {
              this.classes.push(cl);
              clIds.push(cl.id);
            }
          });
        });
      }
    }, 10);
    if (!this.events || this.events.length === 0) {
      this.messageService.getEventMessages().subscribe(
        (resp: {data: EventInterface[]}) => {
          resp.data.map (i => {
            const replacements = [];
            i.models.map(i => {
              i.replacements.map(r => {
                r.itemName = r.name + ' - ' + i.name;
                replacements.push(r);
                if (r.column === 'name' && i.name === 'user') {
                  this.recipientsNameReplacement = r;
                }
              });
            });
            this.events.push({id: i.id, itemName: i.name, models: i.models, name: i.name, replacements: replacements});
          });
        }
      );
    }
    if (!this.conditions || this.conditions.length === 0) {
      this.messageService.getEventConditions().subscribe(
        (resp: {data: ConditionInterface[]}) => {
          this.conditions = resp.data;
          this.selectedCondition = resp.data[0];
        }
      );
    }
  }
  ngAfterViewInit() {
    // const textarea = document.querySelector('textarea');
    // if (textarea) {
    //   textarea.addEventListener('keydown', this.autosize);
    // }
    // const i = 0;
    // const heightBody = $('#message-body').outerHeight();
    // let dragging = false;
    // $('#dragbar').on('mousedown', (e) => {
    //   e.preventDefault();
    //   dragging = true;
    //   const main = $('#message-body-m-text');
    //   const ghostbar = $('<div>',
    //     {id: 'ghostbar',
    //       css: {
    //         height: main.outerHeight(),
    //         width: main.outerWidth(),
    //         top: main.offset().top,
    //         left: main.offset().left
    //       }
    //     }).appendTo('body');
    //
    //   $(document).on('mousemove', (e) => {
    //     const parentOffset = main.parent().offset();
    //
    //     const h = e.pageY - parentOffset.top;
    //     ghostbar.css('height',h);
    //   });

    // });

    // $(document).on('mouseup', (e) => {
    //   if (dragging) {
    //     const parentOffset = $('#message-body-m-text').parent().offset();
    //     const h = e.pageY - parentOffset.top;        const percentage = (h / window.innerHeight) * 100;
    //     const mainPercentage = 100 - percentage;
    //     $('#message-body-m-text').css('height', h + 'px');
    //     // $('#message-body-m-text').css('height',mainPercentage + "%");
    //     $('#ghostbar').remove();
    //     $(document).off('mousemove');
    //     dragging = false;
    //   }
    // });
  }


  setActiveTab(tab, approve = false) {
    if (approve || this.stopEditOrCreate('goToApprovedTab', tab)) {
      this.activeTab = tab;
      this.resetTabsAndPageNumber();
      this.getMessages(tab);
    }
  }
  goToApprovedTab(tab) {
    this.setActiveTab(tab, true);
  }
  getMessages(mode = null) {
    if (!mode) {
      mode = this.activeTab;
    }
    if (isNaN(this.page)) {
      this.page = 0;
    }
   this.messageService.getMessages(mode, this.page).subscribe(
     (resp: {data: Message[]}) => {
       switch (mode) {
         case 'inbox': {
           this.inboxMessages.push(...resp.data);
           break;
         }
         case 'sent': {
           this.sentMessages.push(...resp.data);
           break;
         }
         case 'draft': {
           this.draftMessages.push(...resp.data);
           break;
         }
         case 'trash': {
           this.trashMessages.push(...resp.data);
           break;
         }
         case 'system-messages': {
           const messagesSystem = <SystemMessage[]><unknown>resp.data;
           this.systemMessages.push(...messagesSystem);
           break;
         }
       }
     }
   );
   this.page++;
  }
  clearMessages() {
    const currentMessages = this.getCurrentMessages();
    const messagesToRemove = currentMessages.map(item => item.id);
    if (this.activeTab === 'trash') {
      this.messageService.clearMessageTrash().subscribe(() => {
        this.setActiveTab(this.activeTab);
      });
    } else {
      messagesToRemove.forEach(item => {
        this.messageService.trashMessage(item).subscribe(() => {
          this.setActiveTab(this.activeTab);
        });
      });
    }
  }
  getCurrentMessages() {
    let messages = [];
    this.draggableItems = [];
    switch (this.activeTab) {
      case 'inbox': {
        messages = this.inboxMessages;
        break;
      }
      case 'draft': {
        messages = this.draftMessages;
        break;
      }
      case 'sent': {
        messages = this.sentMessages;
        break;
      }
      case 'trash': {
        messages = this.trashMessages;
        break;
      }
      case 'system-messages': {
        messages = this.systemMessages;
        break;
      }
    }
    // messages.map(m => {
    //   this.draggableItems.push(m.id);
    // });
    return messages;
  }
  truncate(str: String, length: number) {
    return str.length > length ? str.slice(0,length)+'...': str;
  }
  getMessageBody() {
    return !this.creatingNew ? this.selectedMessage.body : '';
  }
  cancelCreating(force = false) {
    if ((this.creatingNew || this.editing) && (force || this.stopEditOrCreate('cancelCreating', true))) {
      this.refreshAll();
      // if (this.selectedMessage) {
      //   this.setSelectedMessage(this.selectedMessage);
      // }
      return true;
    }
    return false;
  }
  stopEditOrCreate(method = null, params = null) {
    if (this.activeTab === 'system-messages' && this.selectedMessage && this.nameSystemMessage && this.subject) {
      const typed = this.selectedMessage.body !== this.htmlContent || (this.selectedMessage.subject !== this.subject.nativeElement.value && this.subject.nativeElement.value !== 'No subject') ||
        this.nameSystemMessage.nativeElement.value !== this.selectedMessage.name;
      let theSameRecipients = true;
      if (this.activeTab === 'system-messages') {
        // theSameRecipients = this.bundleRecipients['school'] ===
      }
      // console.log(this.selectedMessage.body);
      // console.log(this.htmlContent);
      // console.log(this.selectedMessage.subject);
      // console.log(this.subject.nativeElement.value);
      // console.log(this.nameSystemMessage.nativeElement.value);
      // console.log(this.selectedMessage.name);
      if (typed || !theSameRecipients) {
        ConfirmModalComponent.insertedObject = this;
        this.confirmModal = this.dialog.open(ConfirmModalComponent, {panelClass: 'messages-confirm-dialog'});
        ConfirmModalComponent.modalRef = this.confirmModal;
        ConfirmModalComponent.methodDelete = method;
        ConfirmModalComponent.methodDeleteParam = params;
        ConfirmModalComponent.textModal = 'Discard changes?';
        ConfirmModalComponent.textButton = 'Discard';
        return false;
      }
    }
    if (this.activeTab !== 'system-messages') {
      if (this.creatingNew && (this.htmlContent.length > 0 || this.subject.nativeElement.value.length > 0)) {
        if (!this.selectedMessage || this.selectedMessage.status !== 'draft') {
          this.sendMessage('draft');
        }
      }
    }
    this.refreshAll();
    return true;
  }
  setSelectedMessage(message: Message, event) {
    if ((!event || !event.target.classList.contains('for-checkbox')) && !this.selectedMessage || this.selectedMessage.id !== message.id) {
      const connMessage = Object.assign({}, message);
      connMessage.force = true;
      if (message.force && message.force === true || this.stopEditOrCreate('setSelectedMessage', connMessage)) {
        this.selectedMessage = message;
        setTimeout(() => {
          this.selectedThreadId = null;
          this.messagesByThread = null;
          this.recipients = [];
          this.selectedRecipients = [];
          this.selectedRecipientsOrigin = [];
          let recipients = this.activeTab === 'inbox' ? [message.from] : message.to;
          if (this.activeTab !== 'system-messages') {
            this.messageService.getMessagesByThread(message.threadId).subscribe(
              (resp: { data: Message[] }) => {
                this.messagesByThread = resp.data.filter(i => {
                  const cond1 = i.id !== this.selectedMessage.id;
                  if (this.activeTab === 'sent') {
                    return cond1 && i.read_at;
                  }
                  return cond1;
                });
                if (this.activeTab === 'sent') {
                  this.messagesByThread.map(m => {
                    m.to.map(u => {
                      if (!recipients.some(r => r.id === u.id)) {
                        recipients.push(u);
                      }
                    });
                  });
                  recipients = recipients.filter(u => u.id !== this.user.id);
                }
                this.recipientsUsers = recipients;
                recipients.map(r => {
                  if (r) {
                    this.recipients.push(r.id);
                    this.selectedRecipients.push({id: r.id, itemName: r.name});
                    this.selectedRecipientsOrigin.push({id: r.id, itemName: r.name});
                  }
                });
              }
            );
          } else {
            this.nameSystemMessage.nativeElement.value = message.name;
            this.systemMessageMode = message.mode;
            this.recipientsUsers = recipients;
            recipients.map(r => {
              this.recipients.push(r.id);
              const name = r.model_name + ' - ' + r.mode;
              this.selectedRecipients.push({id: r.model_id, itemName: name, mode: message.mode});
              this.bundleRecipients[r.model] = r.model_id;
              this.selectedRecipientsOrigin.push({id: r.model_id, itemName: name, mode: message.mode});
            });
          }
          this.htmlContent = message.body;
          console.log(this.subject);
          // this.creatingNew = this.activeTab === 'draft' || this.activeTab === 'system-messages';
          this.markAsRead(message);
          this.subject.nativeElement.value = !message.subject ? 'No subject' : message.subject;
          console.log(message, this.creatingNew, this.selectedThreadId);
        }, 10);
      }
    }
  }
  sendMessage(mode) {
    if (this.htmlContent.length > 0 && this.recipients.length > 0 || mode === 'draft') {
      const newMessage = new Message();
      newMessage.body = this.htmlContent; //this.body.nativeElement.value;
      newMessage.subject = this.subject.nativeElement.value;
      newMessage.recipients = this.selectedRecipients.map(i => i.id);
      newMessage.creating = true;
      newMessage.status = mode;
      newMessage.id = this.selectedMessage && this.selectedMessage.id ? this.selectedMessage.id : null;
      newMessage.threadId = this.selectedThreadId;
      newMessage.created_at = moment().format('YYYY-MM-DD HH:mm:ss');

      this.refreshAll();
      this.messageService.saveMessage(newMessage).subscribe(
        (resp: { data: Message[] }) => {
          switch (newMessage.status) {
            case 'draft': {
              this.draftMessages = resp.data;
              break;
            }
            case 'sent': {
              ConfirmModalComponent.insertedObject = this;
              ConfirmModalComponent.withButtons = false;
              ConfirmModalComponent.textModal = 'Message successfully sent';
              this.confirmDialog = this.dialog.open(ConfirmModalComponent, {panelClass: 'messages-confirm-dialog'});
              ConfirmModalComponent.modalRef = this.confirmDialog;
              this.setActiveTab('sent');
              break;
            }
          }
        }
      );
    }
  }
  onSaveSystemMessage() {
    if (this.htmlContent.length > 0) {
      const selectedEventsIds = [];
      let days_count = 0;
      if (this.numberConditionsItems) {
        days_count = this.numberConditionsItems.nativeElement.value;
      }
      const specific_day = moment(this.selectedSpecifricDay, 'll').format('YYYY-MM-DD');
      if (this.selectedMessage && this.systemMessageMode === 'event') {
        this.selectedMessage.events.map(e => selectedEventsIds.push(+e.id));
      }
      const body = {
        id: this.selectedMessage && this.selectedMessage.id ? this.selectedMessage.id : null,
        body: this.htmlContent,
        subject: this.subject.nativeElement.value,
        name: this.nameSystemMessage.nativeElement.value,
        system_mode: this.systemMessageMode,
        selected_events: selectedEventsIds,
        recipients_bundle: this.bundleRecipients,
        recipients_role: this.selectedRecipientsRole,
        status: this.selectedMessage ? this.selectedMessage.statusSystem : 0,
        items_number: days_count,
        condition_id: this.selectedCondition ? this.selectedCondition.id : null,
        specific_day: specific_day
      };
      this.messageService.saveSystemMessage(body).subscribe(
        (resp: { data: Message }) => {
          console.log(resp);
          ConfirmModalComponent.insertedObject = this;
          ConfirmModalComponent.withButtons = false;
          ConfirmModalComponent.textModal = 'Template successfully' + (this.selectedMessage && this.selectedMessage.id ? ' updated' : ' created');
          this.confirmDialog = this.dialog.open(ConfirmModalComponent, {panelClass: 'messages-confirm-dialog'});
          ConfirmModalComponent.modalRef = this.confirmDialog;
          this.refreshAll();
          this.setActiveTab('system-messages');
          this.selectedMessage = resp.data;
          this.nameSystemMessage.nativeElement.value = this.selectedMessage.name;
          this.subject.nativeElement.value = !this.selectedMessage.subject ? 'No subject' : this.selectedMessage.subject;
          this.systemMessageMode = this.selectedMessage.mode;
          this.recipientsUsers = this.selectedMessage.to;
          this.selectedMessage.to.map(r => {
            this.recipients.push(r.id);
            const name = r.model_name + ' - ' + r.mode;
            this.selectedRecipients.push({id: r.model_id, itemName: name, mode: this.selectedMessage.mode});
            this.selectedRecipientsOrigin.push({id: r.model_id, itemName: name, mode: this.selectedMessage.mode});
          });
        this.htmlContent = this.selectedMessage.body;
        }
      );
    }
  }
  startCreateNew(dublicate = false) {
    this.creatingNew = true;
    this.editing = false;
    console.log(this.selectedThreadId, dublicate);
    if (!dublicate) {
      this.messagesByThread = [];
      this.htmlContent = '';
      this.recipients = [];
      this.recipientsUsers = [];
      this.selectedRecipientsRole = 'all';
      this.systemMessageMode = 'auto';
      this.selectedRecipients = [];
      this.selectedMessage = null;
      if (this.activeTab === 'system-messages' && this.nameSystemMessage) {
        this.nameSystemMessage.nativeElement.value = '';
      }
      if (!this.selectedThreadId && this.subject) {
        this.subject.nativeElement.value = '';
      }
    } else {
      this.selectedMessage.id = null;
      this.nameSystemMessage.nativeElement.value += ' (copy)';
    }
    setTimeout(() => {
      MessagePageComponent.setUpEditor();
    }, 10);
  }
  ngOnDestroy() {
    this.subscribes.map( s => s.unsubscribe());
    MessagePageComponent.instance = null;
  }
  onScroll() {
    console.log('scrolled');
    this.getMessages();
  }
  resetTabsAndPageNumber() {
    this.inboxMessages = [];
    this.sentMessages = [];
    this.draftMessages = [];
    this.trashMessages = [];
    this.systemMessages = [];
    this.page = 0;
  }
  refreshAll() {
    this.selectedThreadId = null;
    if (this.subject) {
      this.subject.nativeElement.value = '';
    }
    if (this.nameSystemMessage) {
      this.nameSystemMessage.nativeElement.value = '';
    }
    this.recipients = [];
    this.recipientsUsers = [];
    this.creatingNew = false;
    this.editing = false;
    this.selectedRecipients = [];
    this.selectedMessage = null;
    this.htmlContent = '';
  }
  setThreadId() {
    if (this.activeTab !== 'system-messages') {
      this.selectedThreadId = this.selectedMessage.threadId;
      this.accountService.getUserById(this.selectedMessage.from.id).subscribe(
        (resp: { data: User }) => {
          this.recipientsUsers = [resp.data];
          this.recipients = [resp.data.id];
          this.selectedRecipients = [{id: resp.data.id, itemName: resp.data.name}];
          this.selectedRecipientsOrigin = [{id: resp.data.id, itemName: resp.data.name}];
        }
      );
      this.startCreateNew();
    }
  }
  toggleThreadMessage(messageT) {
    if (this.activeTab !== 'system-message') {
      if (this.selectedThreadMessage && this.selectedThreadMessage.id === messageT.id) {
        this.selectedThreadMessage = null;
      } else {
        this.selectedThreadMessage = messageT;
        this.markAsRead(messageT);
      }
    }
  }
  openRecipientsModal(event) {
      console.log(this.selectedRecipients);
      if ((this.creatingNew || this.editing) && !this.selectedThreadId) {
        this.recipients = this.selectedRecipients.map(i => i.id);
        console.log(event.target.closest('.c-remove'));
        if (!event.target.closest('.c-remove')) {
          this.recipientsDialog = this.dialog.open(AddRecipientsComponent);
          this.recipientsDialog.componentInstance.user = this.user;
          this.recipientsDialog.componentInstance.selectedThreadId = this.selectedThreadId;
          this.recipientsDialog.componentInstance.selectedMessage = !!this.selectedMessage;
          this.recipientsDialog.componentInstance.recipients = this.recipients;
          this.recipientsDialog.componentInstance.programs = this.programs;
          this.recipientsDialog.componentInstance.classes = this.classes;
          this.recipientsDialog.componentInstance.schools = this.user.schools;
          this.recipientsDialog.componentInstance.parentRef = this;
          this.recipientsDialog.componentInstance.activeTab = this.activeTab;
          this.recipientsDialog.componentInstance.setRecieversSubject.subscribe(
            (resp: { id: number, itemName: string }[]) => {
              this.recipients = [];
              if (resp) {
                this.selectedRecipients = resp;
                resp.map(i => {
                  this.recipients.push(i.id);
                });
              }
            }
          );
          this.recipientsDialog.componentInstance.selectionChanged.subscribe(
            (resp: { recievers: any, selectedItems: any }) => {
              if (resp) {
                console.log(resp);
                this.setBundleRecipients(resp.recievers, 'select');
                this.selectedRecipients = resp.selectedItems;
              }
            }
          );
          this.recipientsDialog.componentInstance.selectionRecipientsRoleChanged.subscribe(
            (resp: any) => {
              this.setBundleRecipients(resp, 'role');
            }
          );
        }
      }
  }
  getPrograms(schoolId = null) {
    this.programService.getUsersPrograms(schoolId).subscribe(
      (resp: {data: Program[]}) => {
        this.programStore.dispatch(new SetPrograms(resp.data));
        this.programs = resp.data;
        const clIds = [];
        this.classes = [];
        this.programs.map(pr => {
          pr.classes.map(cl => {
            if (!clIds.includes(cl.id)) {
              this.classes.push(cl);
              clIds.push(cl.id);
            }
          });
        });
      }
    );
  }
  getSubject(message) {
    switch (this.activeTab) {
      case 'system-messages' : {
        return message.name ? this.truncate(message.name, 20) : 'no subject';
      }
      default: {
        return message.subject ? this.truncate(message.subject, 20) : 'no subject';
      }
    }
  }
  getBody(message) {
    switch (this.activeTab) {
      case 'system-messages': {
        return '';
        // return message.body;
      }
      case 'inbox': {
        return 'From: ' + (message.from ? message.from.name : '');
        // return message.body;
      }
      case 'trash': {
        return 'From: ' + (message.from ? message.from.name : '');
        // return message.body;
      }
      case 'sent': {
        let msg = 'To: ' + (message.to && message.to[0] ? message.to[0].name : '');
        // if (message.toInThread > 1) {
        //   msg += ' and ' + (message.toInThread - 1) + ' others';
        // }
        return msg;
      }
      default: {
        // return message.preview ? message.preview : '';
      }
    }
  }
  setBundleRecipients(event, mode: string) {
    console.log(event);
    if (mode === 'select') {
      this.bundleRecipients = event;
      this.selectedRecipientsOrigin = [];
      // Object.keys(this.bundleRecipients).map(i => {
      //   if (this.bundleRecipients[i] !== 0) {
      //     this.selectedRecipients.push({id: this.bundleRecipients[i], itemName: i});
      //     console.log(this.selectedRecipients);
      //   }
      // });
    }
    if (mode === 'role' && event) {
      this.selectedRecipientsRole = event;
      this.selectedRecipients.map( r => {
        r.itemName += ' - ' + this.selectedRecipientsRole;
      })
    }
  }
  getModels() {
    const modelsIds = [];
    let models = [];
    if (this.systemMessageMode === 'event' && this.selectedEvents && this.selectedEvents.length > 0) {
      this.selectedEvents.map(i => {
        i.models.map(m => {
          if (!modelsIds.includes(m.id)) {
            modelsIds.push(m.id);
            models.push(m);
          }
        });
      });
      if (this.selectedEvents.length > 1) {
        models = models.filter(m => {
          return this.selectedEvents.every(e => {
            return e.models.some(mo => mo.name === m.name);
          });
        });
      }
    }
    if (this.systemMessageMode === 'auto' && this.selectedCondition) {
      this.selectedCondition.models.map(m => {
        if (!modelsIds.includes(m.id)) {
          modelsIds.push(m.id);
          models.push(m);
        }
      });
    }
    if (this.systemMessageMode === 'once') {
      const onceModels = [];
      this.events.map(e => {
        if (onceModels.length < 2) {
          e.models.map( m => {
            if (onceModels.length < 2 && (m.name === 'user' || m.name === 'admin')) {
              models.push(m);
              onceModels.push(m);
            }
          });
        }
      });
    }
    return models;
  }
  addSlug(replacement: MessageReplacementInterface) {
    this.usedReplacements.push(replacement.slug);
    const width = ((replacement.slug.length + 1) * 8) + 'px';
    this.htmlContent += ' <div class="inline_block"><input data-id="' + replacement.id + '" style="font-size: 14px; text-align: center; width:' + width + '" disabled class="editor-replacement" value="' +  replacement.slug + '"></div><span>&nbsp;</span> ';
  }
  setSelectedCondition(event) {
    this.conditions.map( c => {
      if (c.id === event.value) {
        if (c.name === 'specific_day') {
          this.startDayEdit();
        }
        this.selectedCondition = c;
      }
    });
  }
  startDayEdit() {
    this.calendarDialog = this.dialog.open(ModalCalendarComponent);
    this.calendarDialog.componentInstance.ref = this.calendarDialog;
    const currentDay = moment(this.selectedSpecifricDay, 'll');
    this.calendarDialog.componentInstance.initDate = {year: currentDay.year(), month: currentDay.month()+1, day: currentDay.date()};
    this.calendarDialog.componentInstance.selectedDay.subscribe(
      resp => {
        if (resp) {
          this.selectedSpecifricDay = moment().date(resp.day).month(resp.month - 1).year(resp.year).format('ll');

        }
        console.log(resp);
      }
    );
  }
  // setSystemMessage() {
  //   if (this.systemMessageMode === 'once') {
  //     this.systemMessageMode = 'event';
  //   } else if (this.systemMessageMode === 'event') {
  //     this.systemMessageMode = 'auto';
  //   } else {
  //     this.systemMessageMode = 'once';
  //   }
  // }
  onItemDeSelect(event) {
    if (!this.creatingNew && !this.editing || (this.creatingNew && this.selectedThreadId)) {
      this.selectedRecipients = JSON.parse(JSON.stringify(this.selectedRecipientsOrigin));
    }
  }
  isNothingHappend() {
    return !this.creatingNew && !this.selectedMessage;
  }
  startEdit() {
    this.editing = true;
    setTimeout(() => {
      MessagePageComponent.setUpEditor();
    }, 10);
  }
  onDeleteMsg(event, msg: Message) {
    event.stopPropagation();
    if (this.activeTab === 'trash') {
      this.openPermanentDeleteConfirm(msg);
      return;
    }
    if (this.activeTab !== 'system-messages' && (this.activeTab === 'inbox' || this.isStudentMessagesUser())) {
      this.messageService.trashMessage(msg.id).subscribe(
        resp => this.setActiveTab(this.activeTab)
      );
    }
  }
  isStudentMessagesUser() {
    return !!this.user && ['student', 'student_individual', 'student_group'].includes(this.user.role);
  }
  /* S8 Iteration 896: open shared ConfirmModal for permanent single-message delete from Trash Bin tab. */
  openPermanentDeleteConfirm(msg: Message) {
    ConfirmModalComponent.insertedObject = this;
    this.permanentDeleteMsgRef = this.dialog.open(ConfirmModalComponent, {panelClass: 'messages-confirm-dialog'});
    ConfirmModalComponent.modalRef = this.permanentDeleteMsgRef;
    ConfirmModalComponent.textModal = 'Would you like to delete this message permanently?';
    ConfirmModalComponent.textButton = 'Yes Please';
    ConfirmModalComponent.cancelButtonText = 'No Thanks';
    ConfirmModalComponent.methodDelete = 'onConfirmPermanentDelete';
    ConfirmModalComponent.methodDeleteParam = msg.id;
  }
  /* S8 Iteration 896: callback from ConfirmModal — hard delete + refresh + clear selection if needed. */
  onConfirmPermanentDelete(msgId: number) {
    this.messageService.permanentDeleteMessage(msgId).subscribe(
      resp => {
        if (this.selectedMessage && this.selectedMessage.id === msgId) {
          this.selectedMessage = null;
        }
        this.setActiveTab(this.activeTab);
      }
    );
  }
  openConfirmDelete() {
    ConfirmModalComponent.insertedObject = this;
    this.confirmModalDelete = this.dialog.open(ConfirmModalComponent, {panelClass: 'messages-confirm-dialog'});
    ConfirmModalComponent.modalRef = this.confirmModalDelete;
    ConfirmModalComponent.methodDelete = 'onDeleteSystemMsg';
    ConfirmModalComponent.textModal = 'Delete Template?';
    ConfirmModalComponent.textButton = 'Delete';
  }
  onDeleteSystemMsg() {
    if (this.selectedMessage && !this.selectedMessage.default) {
      this.messageService.deleteSystemMessage(this.selectedMessage.id).subscribe(
        resp => {
          this.refreshAll();
          this.setActiveTab('system-messages')
        }
      );
    }
  }
  redirectTo(page: string) {
    MessagePageComponent.instance = null;
    console.log(page);
    this.router.navigate([page]);
  }
  toggleStatusMsg(event, message) {
    event.stopPropagation();
    message.statusSystem === 0 ? message.statusSystem = 1 : message.statusSystem = 0;
    this.messageService.toggleSystemMessageStatus(message).subscribe(
      (resp: {data: {status: number}}) => {
        this.getCurrentMessages().map((m, i) => {
          if (m.id === message.id) {
            this.getCurrentMessages()[i].statusSystem = resp.data.status;
            console.log(this.getCurrentMessages()[i]);
          }
        });
      }
    );
    console.log(message);
  }
  movedMessage(event) {
    // if (event.delta.x < 0) {
    //   if (this.itemMoved < 20) {
    //     this.itemMoved++;
    //   } else {
    //     console.log(event.delta);
    //     console.log(event.source);
    //     this.itemMoved = 0;
    //   }
    // }
  }
  markAsRead(message) {
    if (!message.read_at && this.activeTab === 'inbox') {
      this.messageService.markAsRead(message).subscribe(
        (resp: { data: { read_at: string, not_read_messages: number } }) => {
          message.read_at = resp.data.read_at;
          this.user.not_read_messages = resp.data.not_read_messages;
          this.authStore.dispatch(new UpdateAuthUser({not_read_messages: resp.data.not_read_messages}));
        }
      );
    }
  }

  /**
   * (708) Applies a text format command without stealing focus/selection.
   * mousedown.preventDefault() on the caller prevents the button from taking
   * focus away from the contenteditable, keeping the active selection intact.
   * execCommand then runs on the still-focused editor with the selection preserved.
   *
   * Used for: Normal (formatBlock p), Heading (formatBlock h2),
   *   Subheading (formatBlock h3), Bold, Italic, Bullet List, Numbered List,
   *   Quote (formatBlock blockquote).
   */
  applyMessageTextCommand(event: MouseEvent, command: string, value?: string): void {
    event.preventDefault();
    try {
      document.execCommand(command, false, value || null);
    } catch (e) { /* ignore — execCommand may throw in some browsers */ }
  }

  /**
   * (708) Inserts a full-width horizontal divider at the current cursor position.
   * Captures the active selection before the button's mousedown can steal focus,
   * restores it and inserts the HR + trailing paragraph via execCommand insertHTML.
   * The divider uses clear:both so it escapes any floated content.
   */
  insertMessageDivider(event: MouseEvent): void {
    event.preventDefault();
    const sel = window.getSelection();
    let savedRange: Range | null = null;
    if (sel && sel.rangeCount > 0) {
      savedRange = sel.getRangeAt(0).cloneRange();
    }
    const html =
      '<div class="mkc-divider-block">' +
        '<hr class="mkc-content-divider">' +
      '</div>' +
      '<p><br></p>';
    try {
      if (savedRange) {
        const editorEl = document.querySelector('.messages-editor-card .angular-editor-textarea') as HTMLElement;
        if (editorEl) { editorEl.focus(); }
        const selRestore = window.getSelection();
        if (selRestore) {
          selRestore.removeAllRanges();
          selRestore.addRange(savedRange);
        }
      }
      document.execCommand('insertHTML', false, html);
    } catch (e) { /* ignore */ }
  }

  // ── (709) Messages media panel controls ──────────────────────────────────────

  onAddVideoBtnMousedown(event: MouseEvent): void {
    event.preventDefault();
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      this.msgSavedRange = sel.getRangeAt(0).cloneRange();
    }
  }

  toggleVideoPanel(): void {
    if (this.videoPanel.open) {
      this.closeVideoPanel();
    } else {
      if (this.imagePanel.open) { this.closeImagePanel(); }
      this.openVideoPanel();
    }
  }

  openVideoPanel(): void {
    this.videoPanel.open = true;
    this.videoPanel.error = '';
  }

  closeVideoPanel(): void {
    this.videoPanel.open = false;
    this.videoPanel.urlValue = '';
    this.videoPanel.embedValue = '';
    this.videoPanel.error = '';
    this.videoPanel.mode = 'url';
  }

  isVideoInsertDisabled(): boolean {
    if (this.videoPanel.mode === 'url') { return !this.videoPanel.urlValue.trim(); }
    if (this.videoPanel.mode === 'embed') { return !this.videoPanel.embedValue.trim(); }
    return true;
  }

  insertVideo(): void {
    let html: string | null = null;
    if (this.videoPanel.mode === 'url') {
      const src = this.resolveVideoEmbedSrc(this.videoPanel.urlValue.trim());
      if (!src) {
        this.videoPanel.error = 'Unrecognised URL. Paste a YouTube or Vimeo link.';
        return;
      }
      html = this.wrapMsgIframe(src);
    } else {
      html = this.buildMsgVideoHtmlFromEmbed(this.videoPanel.embedValue.trim());
      if (!html) {
        this.videoPanel.error = 'Could not read iframe src from embed code. Check it contains a valid https:// src.';
        return;
      }
    }
    this.insertHtmlIntoMsgEditor(html);
    this.closeVideoPanel();
  }

  private resolveVideoEmbedSrc(url: string): string | null {
    // YouTube patterns
    let m = url.match(/(?:youtube\.com\/watch\?(?:.*&)?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/);
    if (m) { return `https://www.youtube.com/embed/${m[1]}`; }
    // Vimeo patterns
    m = url.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/);
    if (m) { return `https://player.vimeo.com/video/${m[1]}`; }
    return null;
  }

  private buildMsgVideoHtmlFromEmbed(embedCode: string): string | null {
    if (/\<script/i.test(embedCode)) { return null; }
    const m = embedCode.match(/src=["'](https?:\/\/[^"']+)["']/i);
    if (!m) { return null; }
    return this.wrapMsgIframe(m[1]);
  }

  private wrapMsgIframe(src: string): string {
    const size = this.videoPanel.videoSize || 'medium';
    const layout = this.videoPanel.videoLayout || 'center';
    const outerSizeClass = size === 'small' ? ' mkc-video-outer--small'
                         : size === 'large'  ? ' mkc-video-outer--large'
                         :                     ' mkc-video-outer--medium';
    const layoutClass = ` mkc-media-layout mkc-media-layout--${layout}`;
    return (
      `<div class="mkc-media-block">` +
      `<div class="mkc-video-outer${outerSizeClass}${layoutClass}">` +
      `<div class="mkc-video-wrapper" style="position:relative;width:100%;` +
      `padding-bottom:56.25%;height:0;overflow:hidden;">` +
      `<iframe src="${src}" ` +
      `style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" ` +
      `frameborder="0" allowfullscreen ` +
      `allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">` +
      `</iframe></div>` +
      `</div>` +
      this.msgMediaHelperHtml +
      `</div><p><br></p>`
    );
  }

  toggleImagePanel(): void {
    if (this.imagePanel.open) {
      this.closeImagePanel();
    } else {
      if (this.videoPanel.open) { this.closeVideoPanel(); }
      this.openImagePanel();
    }
  }

  openImagePanel(): void {
    this.imagePanel.open = true;
  }

  closeImagePanel(): void {
    this.imagePanel.open = false;
  }

  chooseImage(): void {
    const wrapperEl = document.querySelector('.messages-editor-card') as HTMLElement;
    if (!wrapperEl) { return; }
    const fileInput = wrapperEl.querySelector('input[type="file"][accept="image/*"]') as HTMLInputElement;
    if (!fileInput) { return; }

    if (this.msgImagePanelObserver) {
      this.msgImagePanelObserver.disconnect();
      this.msgImagePanelObserver = null;
    }

    const editorTextarea = wrapperEl.querySelector('.angular-editor-textarea') as HTMLElement;
    if (!editorTextarea) { fileInput.click(); return; }

    const imgSize = this.imagePanel.imageSize || 'small';
    const imgLayout = this.imagePanel.imageLayout || 'center';

    this.msgImagePanelObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i] as HTMLElement;
          const imgs: HTMLImageElement[] = [];
          if (node.nodeName === 'IMG') { imgs.push(node as HTMLImageElement); } else if (node.querySelectorAll) {
            node.querySelectorAll('img').forEach((img) => imgs.push(img));
          }
          imgs.forEach((img) => {
            img.classList.add('mkc-editor-image', `mkc-editor-image--${imgSize}`);
            img.classList.add('mkc-media-layout', `mkc-media-layout--${imgLayout}`);
            setTimeout(() => {
              try {
                const range = document.createRange();
                range.setStartAfter(img);
                range.collapse(true);
                const sel = window.getSelection();
                if (sel) { sel.removeAllRanges(); sel.addRange(range); }
                document.execCommand('insertHTML', false, this.msgMediaHelperHtml + '<p><br></p>');
              } catch (e) { /* ignore */ }
            }, 0);
          });
          if (imgs.length > 0) {
            if (this.msgImagePanelObserver) {
              this.msgImagePanelObserver.disconnect();
              this.msgImagePanelObserver = null;
            }
            this.closeImagePanel();
            return;
          }
        }
      }
    });

    this.msgImagePanelObserver.observe(editorTextarea, { childList: true, subtree: true });

    setTimeout(() => {
      if (this.msgImagePanelObserver) {
        this.msgImagePanelObserver.disconnect();
        this.msgImagePanelObserver = null;
      }
    }, 30000);

    fileInput.click();
  }

  private insertHtmlIntoMsgEditor(html: string): void {
    const editorEl = document.querySelector('.messages-editor-card .angular-editor-textarea') as HTMLElement;
    if (editorEl) { editorEl.focus(); }
    if (this.msgSavedRange) {
      const sel = window.getSelection();
      if (sel) { sel.removeAllRanges(); sel.addRange(this.msgSavedRange); }
      this.msgSavedRange = null;
    }
    try {
      document.execCommand('insertHTML', false, html);
    } catch (e) {
      this.htmlContent = (this.htmlContent || '') + html;
    }
  }

  setTheme(theme: 'light' | 'dark') {
    this.isDarkTheme = theme === 'dark';
    localStorage.setItem('mkc-dashboard-theme', theme);
    this.applyTheme();
  }

  private applyTheme() {
    const shell = document.getElementById('page-wrapper');
    if (shell) {
      shell.classList.toggle('theme-dark', this.isDarkTheme);
    }
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', this.isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', this.isDarkTheme);
  }

  static setUpEditor() {
    let divWrap;
    let buttonExpand;
    let buttonCollaps;
    const toolbarSets = $('.angular-editor-toolbar-set');
    console.log(toolbarSets);
    toolbarSets.map(i => {
      if (!divWrap) {
        divWrap = $(toolbarSets[i]).clone();
        divWrap.children().remove();
      }
      const children = $(toolbarSets[i]).children();
      let disabled = 0;
      children.map(ch => {
        if (children[ch].tagName.toLowerCase() === 'button' && (!buttonExpand || !buttonCollaps)) {
          buttonExpand = $(children[ch]).clone();
          buttonExpand.attr('title', 'Expand');
          buttonExpand.attr('id', 'expand-');
          buttonExpand.text('Expand');
          buttonExpand.find('i').remove();
          buttonCollaps = $(children[ch]).clone();
          buttonCollaps.attr('title', 'Collaps');
          buttonCollaps.attr('id', 'collaps-');
          buttonCollaps.text('Collaps');
          buttonCollaps.find('i').remove();
        }
        // console.log(children[ch], window.getComputedStyle(children[ch]).display);
        if (window.getComputedStyle(children[ch]).display === 'none' || children[ch].tagName.toLowerCase() === 'label') {
          disabled++;
        }
      });
      // console.log(children.length, disabled);
      if (children.length === disabled) {
        toolbarSets[i].classList.add('disabled-buttons-block')
      }
    });
    divWrap.append([buttonExpand, buttonCollaps]);
    const editorToolBar = $('.angular-editor-toolbar');
    editorToolBar.addClass('editor-collapsed');
    editorToolBar.append(divWrap);
    $('#expand-').on('click', (e) => {
      editorToolBar.removeClass('editor-collapsed').addClass('editor-expanded');
      toolbarSets.children('button').css('display', 'block');
      toolbarSets.children('select').css('display', 'block');
    });
    $('#collaps-').on('click', (e) => {
      editorToolBar.removeClass('editor-expanded').addClass('editor-collapsed');
      toolbarSets.children('button').css('display', 'none');
      toolbarSets.children('select').css('display', 'none');
    });
  }

}
